import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Grid, Label} from 'semantic-ui-react';
import GeneratedOrder from './generatedCode';
import DispatchTurn from './dispatchTurn';

class FileInfo extends Component {
  render() {
    const {filename, count} = this.props;

    if (!filename || !count) {
      return null;
    }

    return (
      <Grid.Row>
        <Grid.Column width='10' textAlign='left'>
          <strong>Líneas: </strong>
          <Label circular color='grey' size='medium'>{count}</Label>
          <strong>Archivo: </strong> {filename}
          <DispatchTurn />
        </Grid.Column>
        <GeneratedOrder />
      </Grid.Row>
    );
  }
}

const mapStateToProps = (state) => {
  const {filename, list = []} = state.dealerStockOrders;
  
  return {
    filename,
    'count': list.length,
  };
};

export default connect(mapStateToProps)(FileInfo);
